import { aoFalharVersaoLeve, versaoLeve } from '@/lib/mediaLeve';

export interface CopyPreview {
    midiaUrl?: string | null;
    video?: boolean;
    texto?: string | null;
    subtitulo?: string | null;
    botoes: string[];
}

interface PreviewCopyProps {
    /** Um bloco ou a criativa inteira (vários blocos, empilhados na ordem real). */
    copy: CopyPreview | CopyPreview[] | null;
    titulo: string;
    linhas: string[];
    utm?: string;
    carregando?: boolean;
}

/** Template como chega no Messenger: mídia, texto e botões na ordem real; números ao lado. */
export default function PreviewCopy({ copy, titulo, linhas, utm, carregando }: PreviewCopyProps) {
    const blocos = (Array.isArray(copy) ? copy : copy ? [copy] : [])
        .filter(c => c.midiaUrl || c.texto || c.subtitulo || c.botoes.length);
    return (
        <div className="pvwrap">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {carregando ? (
                    <div className="pv"><div className="pv-txt muted">Carregando a copy…</div></div>
                ) : blocos.length === 0 ? (
                    <div className="pv"><div className="pv-txt muted">Sem copy cadastrada.</div></div>
                ) : blocos.map((c, bi) => (
                    <div className="pv" key={bi}>
                        {c.midiaUrl && (c.video ? (
                            <video className="pv-media" src={c.midiaUrl} preload="metadata" muted />
                        ) : (
                            <img
                                className="pv-media"
                                src={versaoLeve(c.midiaUrl)}
                                onError={e => aoFalharVersaoLeve(e, c.midiaUrl)}
                                loading="lazy"
                                alt=""
                            />
                        ))}
                        {c.texto && <div className="pv-txt">{c.texto}</div>}
                        {c.subtitulo && <div className="pv-sub">{c.subtitulo}</div>}
                        {c.botoes.map((b, i) => <span className="pv-btn" key={`${b}-${i}`}>{b}</span>)}
                    </div>
                ))}
            </div>
            <div className="pv-meta">
                <b style={{ fontSize: 12.5, color: 'var(--ink)' }}>{titulo}</b>
                {linhas.map((l, i) => <div key={i} style={{ marginTop: 4 }}>{l}</div>)}
                {utm && <div className="utm">{utm}</div>}
            </div>
        </div>
    );
}
